/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue');

window.BootstrapTable = require('bootstrap-table');

window.BootstrapVue = require('bootstrap-vue');
window.Vue.use(BootstrapVue);

window.noty = require('noty');

window.draggable = require('vuedraggable');

window.MediumEditor =  require('medium-editor');

window.summernote =  require('summernote/dist/summernote-bs4.js');

window.VueTelInput = require('vue-tel-input');

window.TimeMe = require('timeme.js');

window.VueSpeedometer = require('vue-speedometer');






/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i);
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));


Vue.component('builder', require('./components/Builder.vue').default);


Vue.component('builder-name-pop', require('./components/BuilderNamePop.vue').default);

Vue.component('bootstrap-table-users', require('./components/BootstrapTableUsers.vue').default);

Vue.component('bootstrap-table-deck-drafts', require('./components/BootstrapTableDeckDrafts.vue').default);
Vue.component('bootstrap-table-deck-sent', require('./components/BootstrapTableDeckSent.vue').default);
Vue.component('bootstrap-table-deck-templates', require('./components/BootstrapTableDeckTemplates.vue').default);

Vue.component('noty', require('./components/Noty.vue').default); 

Vue.component('bootstrap-table-contacts', require('./components/BootstrapTableContacts.vue').default);
Vue.component('bootstrap-table-deck-send-contacts', require('./components/BootstrapTableDeckSendContacts.vue').default);
Vue.component('bootstrap-table-deck-send-capsule-contacts', require('./components/BootstrapTableDeckSendCapsuleContacts.vue').default);
Vue.component('bootstrap-table-mailinglists', require('./components/BootstrapTableMailinglists.vue').default);
Vue.component('bootstrap-table-mailinglist-contacts', require('./components/BootstrapTableMailinglistContacts.vue').default);
Vue.component('bootstrap-table-manage-mailinglist-contacts', require('./components/BootstrapTableManageMailinglistContacts.vue').default);
Vue.component('bootstrap-table-mailinglist-contacts-available', require('./components/BootstrapTableMailinglistContactsAvailable.vue').default);



Vue.component('bootstrap-admin-table-companies', require('./components/BootstrapAdminTableCompanies.vue').default);
Vue.component('bootstrap-admin-table-users', require('./components/BootstrapAdminTableUsers.vue').default);
Vue.component('bootstrap-admin-table-block-templates', require('./components/BootstrapAdminTableBlockTemplates.vue').default);
Vue.component('bootstrap-admin-table-block-navs', require('./components/BootstrapAdminTableBlockNavs.vue').default);
Vue.component('bootstrap-admin-table-stripe-plans', require('./components/BootstrapAdminTableStripePlans.vue').default);
Vue.component('bootstrap-admin-table-stripe-tax-rates', require('./components/BootstrapAdminTableStripeTaxRates.vue').default);
Vue.component('bootstrap-admin-table-credit-bundles', require('./components/BootstrapAdminTableCreditBundles.vue').default);


Vue.component('admin-block-to-nav', require('./components/BlockAddToNav.vue').default);


Vue.component('blocktemplatecodebuilder', require('./components/blockTemplateCodeBuilder.vue').default);


Vue.component('upload-avatar', require('./components/UploadAvatar.vue').default);
Vue.component('upload-image', require('./components/UploadImage.vue').default);



Vue.component('company-logo', require('./components/CompanyLogo.vue').default);
Vue.component('new-company-logo', require('./components/NewCompanyLogo.vue').default);
Vue.component('deck-background', require('./components/DefaultDeckBackground.vue').default);
Vue.component('profile-background', require('./components/ProfileBackground.vue').default);
Vue.component('profile-image', require('./components/ProfileImage.vue').default);


Vue.component('color-picker', require('./components/VerteColorPicker.vue').default);
Vue.component('color-picker-text', require('./components/VerteColorPickerText.vue').default);
Vue.component('company-color-picker', require('./components/CompanyColorPicker.vue').default);

Vue.component('sd-media-manager', require('./components/sizzledeck-media-manager/MediaManager.vue').default);
Vue.component('sd-media-modal', require('./components/sizzledeck-media-manager/MediaModal.vue').default);
Vue.component('sd-top-toolbar', require('./components/sizzledeck-media-manager/subcomponents/TopToolBar.vue').default);
Vue.component('sd-preview-sidebar', require('./components/sizzledeck-media-manager/subcomponents/PreviewSideBar.vue').default);
Vue.component('sd-modal-delete-item', require('./components/sizzledeck-media-manager/subcomponents/ConfirmDeleteModal.vue').default);
Vue.component('sd-modal-move-item', require('./components/sizzledeck-media-manager/subcomponents/MoveItemModal.vue').default);
Vue.component('sd-modal-create-folder', require('./components/sizzledeck-media-manager/subcomponents/CreateFolderModal.vue').default);
Vue.component('sd-modal-rename-item', require('./components/sizzledeck-media-manager/subcomponents/RenameItemModal.vue').default);
Vue.component('sd-modal-errors', require('./components/sizzledeck-media-manager/subcomponents/MediaErrors.vue').default);


Vue.component('deck-send-form', require('./components/DeckSendForm.vue').default);
Vue.component('send-deck-form', require('./components/SendDeckForm.vue').default); // New One

Vue.component('add-contact-to-mailinglist', require('./components/ContactAddToMailinglist.vue').default);

Vue.component('speedometer', require('./components/Speedometer.vue').default);

Vue.component('convert-datetime', require('./components/ConvertDatetime.vue').default);

Vue.component('copy-link-to-clipboard', require('./components/CopyToClipboard').default);

Vue.component('card-element', require('./components/StripeCardElement.vue').default);
Vue.component('checkout-subscribe-new', require('./components/CheckoutNewSub').default);

Vue.component('checkout-subscribe-confirm', require('./components/CheckoutNewSubConfirm').default);

Vue.component('checkout-payment-new', require('./components/CheckoutNewPaymentMethod').default);
Vue.component('swap-subscription', require('./components/SwapSub').default);

Vue.component('checkout-credits', require('./components/CheckoutCredits').default);

Vue.component('setup-modal', require('./components/Setup.vue').default);
Vue.component('signup-form', require('./components/Signup.vue').default);

Vue.component('credits', require('./components/GetCredits.vue').default);

Vue.component('mobile-detect', require('./components/MobileDetect.vue').default);
Vue.component('wizard-mobile-detect', require('./components/SetupWizardMobileDetect.vue').default);

Vue.component('debug', require('./components/DebugComponent.vue').default);

Vue.component('devicepreviewbar', require('./components/PreviewOnDeviceBar.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app',
});

